import React, { useState } from 'react';
import { FILTER_QUERY_BUILDER_TABS, FILTER_TYPES } from '_constants/old/filters';
import { QueryBuilderContainer } from 'modules/Modals/old/FilterModal/components/QueryBuilderContainer';
import PropTypes from 'prop-types';
import { VisitDateAgencyStatus } from './VisitDateAgencyStatus';
import VisitCharacteristics, { useVisitCharacteristicsTabs } from './VisitCharacteristic';
import EducationCharacteristics, { useEducationCharacteristicsTabs } from './EducationCharacteristic';
import AssessmentCharacteristics, { useAssessmentCharacteristicsTabs } from './AssessmentCharacteristic';
import VisitsRetailerCharacteristics from './VisitsRetailerCharacteristics';
import * as Styled from './styles';

export const VisitsQueryBuilder = ({ filterType }) => {
  const [activeTab, setActiveTab] = useState(null);

  // Compute the Visit Characteristics content for the current visit type so we can hide the whole
  // "Visit Characteristics and Outcomes" tab when every filter inside it is hidden (e.g. Assessment
  // on a non-VA account without the assessment-results permission). Hooks must run unconditionally,
  // so we resolve all three and then pick the one matching filterType.
  const enforcementTabs = useVisitCharacteristicsTabs();
  const educationTabs = useEducationCharacteristicsTabs();
  const assessmentTabs = useAssessmentCharacteristicsTabs();

  const visitCharacteristicsTabsByType = {
    [FILTER_TYPES.ENFORCEMENT]: enforcementTabs,
    [FILTER_TYPES.EDUCATION]: educationTabs,
    [FILTER_TYPES.ASSESSMENT]: assessmentTabs,
  };
  const hasVisitCharacteristicsTabs = (visitCharacteristicsTabsByType[filterType] || []).length > 0;

  const TABS = [
    {
      id: 1,
      title: FILTER_QUERY_BUILDER_TABS.VISIT_DATE_AGENCY_STATUS,
    },
    hasVisitCharacteristicsTabs && {
      id: 2,
      title: FILTER_QUERY_BUILDER_TABS.VISIT_CHARACTERISTICS,
    },
    {
      id: 3,
      title: FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS,
    },
  ].filter(Boolean);

  const getVisitCharacterisitcsPage = (type) => {
    switch (type) {
      case FILTER_TYPES.ENFORCEMENT:
        return <VisitCharacteristics />;
      case FILTER_TYPES.ASSESSMENT:
        return <AssessmentCharacteristics />;
      case FILTER_TYPES.EDUCATION:
        return <EducationCharacteristics />;
      default:
        return null;
    }
  };

  const displayContent = () => {
    switch (activeTab) {
      case FILTER_QUERY_BUILDER_TABS.VISIT_DATE_AGENCY_STATUS:
        return <VisitDateAgencyStatus filterType={filterType} />;
      case FILTER_QUERY_BUILDER_TABS.VISIT_CHARACTERISTICS:
        return getVisitCharacterisitcsPage(filterType);
      case FILTER_QUERY_BUILDER_TABS.RETAILER_CHARACTERISTICS:
        return <VisitsRetailerCharacteristics />;
      default:
        return null;
    }
  };

  return (
    <Styled.Wrapper>
      <QueryBuilderContainer tabs={TABS} id="wrapper" activeTab={activeTab} setActiveTab={setActiveTab}>
        {displayContent()}
      </QueryBuilderContainer>
    </Styled.Wrapper>
  );
};

VisitsQueryBuilder.propTypes = {
  filterType: PropTypes.string.isRequired,
};
